import { createFileRoute, redirect } from "@tanstack/react-router";
import { AppShell } from "@/components/app/shell/app-shell";
import { AppShellPending } from "@/components/app/route-pending";
import { useAuth } from "@/features/auth/store";

export const Route = createFileRoute("/_app")({
  beforeLoad: async ({ location }) => {
    const me = await useAuth.getState().bootstrap();
    if (!me)
      throw redirect({ to: "/login", search: { redirect: location.href } });
  },
  component: AppShell,
  // beforeLoad refreshes the session and fetches /me before anything renders. Without this the
  // whole cold start is a blank white page.
  pendingComponent: AppShellPending,
});
